<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
<template>
    <section class="step-item step-groups">
        <section class="step-item__title">
            <h2>Szablony posiedzeń</h2>
        </section>
        <section class="step-item__body">
            <section class="step-item__body__item flex-column" v-if="getTemplates.length > 0">
                <p>Wybierz szablony porządku obrad, które chcesz przenieść do nowej kadencji:</p>
                <section v-for="(item, index) in getTemplates" :key="index">
                    <CheckBoxButton :id="item.id"
                                    :value="item.id"
                                    @setGroupId="(val) => ($store.state.wizardNewCadence.selectedTemplates = val)"
                                    :idsArray="$store.state.wizardNewCadence.selectedTemplates"
                                    :checked="$store.state.wizardNewCadence.selectedTemplates.indexOf(item.id) !== -1" />
                    <label :for="item.id" style="cursor: pointer">ID: {{ item.id }}. {{item.signature}}</label>
                </section>
            </section>
            <section class="step-item__body__item flex-column " v-else>
                Brak dostępnych szablonów w obecnej kadencji do przeniesienia.
            </section>
        </section>
        <section class="step-item__footer">
            <ButtonWithIcon :icon="'additional-arrow'" :text="'Wstecz'" class="btn-step-item btn-reverse" @click="movePrev" />
            <ButtonIconAppend :icon="'additional-arrow'" class="btn-step-item" @click="moveNext">
                Dalej
            </ButtonIconAppend>
        </section>
    </section>
</template>
<script charset="utf-8">
        import wizardNewCadenceService from "../../../../services/wizard.new.cadence.service";
        import CheckBoxButton from "../../../BasicControls/CheckBoxButton.vue";
        import ButtonWithIcon from "../../../BasicControls/ButtonWithIcon.vue";
        import ButtonIconAppend from "../../../BasicControls/ButtonIconAppend.vue";

        export default {
            name: "Step4Templates",
            components: {
                CheckBoxButton,
                ButtonWithIcon,
                ButtonIconAppend
            },
            computed: {
                getTemplates() {
                    return this.$store.state.wizardNewCadence.availableTemplates;
                },
            },
            async mounted() {
                try {
                    this.$store.commit("setWizardNewCadenceBusyStatus", true);
                    this.$store.commit("setWizardNewCadenceCurrentStep", 4);
                    await this.internalFetchAvailableTemplates();
                }
                finally {
                    this.$store.commit("setWizardNewCadenceBusyStatus", false);
                }
            },
            methods: {
                async internalFetchAvailableTemplates() {
                    let response = await wizardNewCadenceService.getClientTemplates();
                    if (response.status === 200)
                        this.$store.state.wizardNewCadence.availableTemplates = response.data;

                },

                async moveNext() {
                    try {
                        this.$store.commit("setWizardNewCadenceBusyStatus", true);
                        this.$store.commit("setWizardNewCadenceStepsDone", 4);
                        await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 5 } });
                        this.$store.commit("setWizardNewCadenceCurrentStep", 5);
                    }
                    catch {
                        this.$store.commit("setWizardNewCadenceBusyStatus", false);
                    }
                },

                async movePrev() {
                    try {
                        this.$store.commit("setWizardNewCadenceBusyStatus", true);
                        await this.$router.push({ name: "NewCadenceWizardsSteps", params: { "step": 3 } });
                        this.$store.commit("setWizardNewCadenceCurrentStep", 3);
                    }
                    catch {
                        this.$store.commit("setWizardNewCadenceBusyStatus", false);
                    }
                },
            }
        }
</script>
<style lang="scss">
    @import "@/assets/scss/wizard-generic-step.scss";
</style>
